import { render, staticRenderFns } from "./UserSupply.vue?vue&type=template&id=edcbea34&scoped=true&"
import script from "./UserSupply.vue?vue&type=script&lang=js&"
export * from "./UserSupply.vue?vue&type=script&lang=js&"
import style0 from "./UserSupply.vue?vue&type=style&index=0&id=edcbea34&scoped=true&lang=css&"
import style1 from "./UserSupply.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcbea34",
  null
  
)

export default component.exports